export default __webpack_public_path__ + "static/SONY_WDRMODE_1_ALL_AUTO_NIGHT_thumb-d36ea7e86036090186f5c5d539797821.webp";